import { isProductionDomain } from "./configUtil";
import { isStagingDomain } from "./configUtil";

/**
 * Get the Client ID
 * @returns the Client Id
 */
function getClientId() {
  return isProductionDomain() ? process.env.REACT_APP_PROD_CLIENT_ID : isStagingDomain() ? process.env.REACT_APP_STG_CLIENT_ID : process.env.REACT_APP_CLIENT_ID;
}

/**
 * Get the Okta Authorization Server Issuer URL
 * @returns the Okta Authorization Server Issuer URL
 */
function getIssuerUrl() {
  return isProductionDomain() ? process.env.REACT_APP_PROD_ISSUER : isStagingDomain() ? process.env.REACT_APP_STG_ISSUER : process.env.REACT_APP_ISSUER;
}


export default {
  oidc: {
    clientId: getClientId(),
    issuer: getIssuerUrl(),
    redirectUri: window.location.origin + '/authorization-code/callback',
    postLogoutRedirectUri: window.location.origin + '/logged_out',
    scopes: [
      "scope:tech:dev-portal:api-products:modify",
      "scope:tech:dev-portal:api-products:read",
      "scope:tech:dev-portal:api-specs:modify",
      "scope:tech:dev-portal:api-specs:read",
      "scope:tech:dev-portal:companies:modify",
      "scope:tech:dev-portal:companies:service-accounts:modify",
      "scope:tech:dev-portal:companies:read",
      "scope:tech:dev-portal:companies:service-accounts:read",
      "scope:tech:dev-portal:domains:modify",
      "scope:tech:dev-portal:domains:read",
      "scope:tech:dev-portal:email:send",
      "scope:tech:dev-portal:user-registrations:read",
      "scope:tech:dev-portal:user-registrations:modify",
      "scope:tech:dev-portal:users:modify",
      "scope:tech:dev-portal:users:read",
      "scope:tech:dev-portal:notifications:modify",
      "scope:tech:dev-portal:notifications:read",
      "scope:tech:dev-portal:api-access-requests:read",
      "scope:tech:dev-portal:api-access-requests:modify",
      "scope:tech:dev-portal:companies:applications:modify",
      "scope:tech:dev-portal:companies:applications:read",
      "scope:tech:dev-portal:identity-providers:authorization-servers:read",
      "scope:tech:dev-portal:identity-providers:read",
      "scope:tech:dev-portal:companies:service-accounts:modify",
      "openid",
      "profile",
      "email"],
    pkce: true
  }
};